import { FC, useContext, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from 'primereact/inputtext';
import { HiOutlineIdentification } from 'react-icons/hi'
import {  IOperativeScenario } from "../../models/ScenarioModel";
import { error, success, warning } from "../../utils/notifications";
import {  deleteOperativeScenarioByID, getOperativeScenarioByTabID, updateOperativeScenario } from "../../services/scenario-service";
import { BsFillSendCheckFill } from "react-icons/bs";
import {  FaPeopleCarry, FaStar } from "react-icons/fa";
import { catchResponse, getWeekNumber } from "../../utils/helperFunctions";
import { UserContext } from "../../Redux/UserContext";
import { HiOutlineTrash } from "react-icons/hi2";
import { Tooltip } from "primereact/tooltip";
import { SpeedDial } from "primereact/speeddial";
import {  AiFillSave, AiOutlineStock } from "react-icons/ai";
import { ScenarioSelector } from "../Scenario/ScenarioSelector/ScenarioSelector";


import { FiCommand } from "react-icons/fi";
import { Entregas } from "./Entregas/Entregas";
import { StockInicial } from "./StockInicial/StockInicia";
import { Trucks } from "./Trucks/Trucks";
import { Proveedores } from "./Proveedores/Proveedores";
import { Button } from "primereact/button";
import {GiFallingStar} from 'react-icons/gi'
import { ChangeReferenceSimulationModal } from "./ChangeReferenceSimulationModal/ChangeReferenceSimulationModal";
import { endOfWeek, startOfWeek } from "date-fns";
import { VscDebugRestart } from "react-icons/vsc";
import { getAllScenarios } from "../../services/home-service";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";

export const OperativeScenario:FC<any> = (props):JSX.Element => {

    const { history } = props

    const [state] = useContext(UserContext)

    const [flagWeek, setFlagWeek] = useState<boolean>(false)

    const [saveLoading, setSaveLoading] = useState<boolean>(false)

    const [changesFlag, setChangesFlag] = useState<boolean>(true)

    const [deleteLoading, setDeleteLoading] = useState<boolean>(false)

    const [allScenarios, setAllScenarios] = useState<any[]>([])

    const [date, setDate] = useState<any>();
    const [week, setWeek] = useState<any>();

    const INITIAL_STATE_STOCK:any = {
        stock_kpis: [],
        stock_series: []
    }

    const INITIAL_STATE_PROVEEDORES:any = {
        herbaceo : {
            herbaceo_propio_table: [],
            herbaceo_proveedores_table: []
        },
        lenhoso: {
            lenhoso_propio_table : [],
            lenhoso_proveedores_table : []
        }
    }

    const INITIAL_STATE_TRUCKS:any = {
        camiones_series : [],
        camiones_table : []
    }

    const INITIAL_STATE_ENTREGAS:any = {
        entregas_table : []
    }

    const [visible, setVisible] = useState<boolean>(false)

    const [simulatedScenarios, setSimulatedScenarios] = useState<any[]>([])

    const [entregas, setEntregas] = useState<any>(INITIAL_STATE_ENTREGAS)

    const [entregasMASTER, setEntregasMASTER] = useState<any>(INITIAL_STATE_ENTREGAS)

    const [stock, setStock] = useState<any>(INITIAL_STATE_STOCK)

    const [stockMASTER, setStockMASTER] = useState<any>(INITIAL_STATE_STOCK)

    const [trucks, setTrucks] = useState<any>(INITIAL_STATE_TRUCKS)

    const [trucksMASTER, setTrucksMASTER] = useState<any>(INITIAL_STATE_TRUCKS)

    const [proveedores, setProveedores] = useState<any>(INITIAL_STATE_PROVEEDORES)

    const [proveedoresMASTER, setProveedoresMASTER] = useState<any>(INITIAL_STATE_PROVEEDORES)

    

    const INITIAL_STATE_SCENARIO:IOperativeScenario = {
        id_scenario: 1,
        name_scenario: "",
        id_plant: 1,
        name_plant: "",
        id_planner: 3,
        name_planner: "",
        simulation: undefined,
        settings: {
            entregas : {
                entregas_table: [],
                
            },
            proveedores : {
                herbaceo : {
                    herbaceo_propio_table: [],
                    herbaceo_proveedores_table: []
                },
                lenhoso: {
                    lenhoso_propio_table : [],
                    lenhoso_proveedores_table : []
                }
            },
            camiones : {
                camiones_series : [],
                camiones_table : []
            },
            stock: {
                stock_kpis: [],
                stock_series: []
            }
        }
    }

    const handleOpenChangeReferenceSimulationModal = () => {
        setVisible(true)
    }

    const [scenarioBase, setScenarioBase] = useState<IOperativeScenario>(INITIAL_STATE_SCENARIO)

    const items = [
        {
            label: 'Cambiar simulación referencia',
            icon: <GiFallingStar />,
            disabled: state?.rol_id !== undefined? [3,4].includes(state?.rol_id) || !state?.id_plants.includes(scenarioBase.id_plant) : false,
            command: (e:any) => {
                handleOpenChangeReferenceSimulationModal()
                
            }
        },
        {
            label: 'Eliminar escenario operativo',
            icon: <HiOutlineTrash />,
            disabled: state?.rol_id !== undefined? [3,4].includes(state?.rol_id) || !state?.id_plants.includes(scenarioBase.id_plant) : false,
            command: (e:any) => {
                confirm(e)
                
            }
        }
        
    ];

    const accept = async() => {
        try {
            setDeleteLoading(true)
            const res = await deleteOperativeScenarioByID(id)
            if(res.status === 200) {
                const { message, code } = res.data
                if(code === 200) {
                    success("El escenario se ha eliminado correctamente.")
                    setDeleteLoading(false)
                    history.push("/home")
                } else {
                    setDeleteLoading(false)
                    error(message)
                }
            }
        } catch(err:any) {
            setDeleteLoading(false)
            catchResponse(err)
        }
    }

    const reject = () => {
        
    }

    const confirm = (event:any) => {
        confirmPopup({
            target: event.originalEvent.currentTarget,
            message: '¿Estás seguro de que deseas eliminar el escenario operativo?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Si',
            rejectLabel:'No',
            accept,
            reject
        });
    };


    


    const [loadingScenarioComparision, setLoadingScenarioComparision] = useState<boolean>(false)

    const [loadingTab, setLoadingTab] = useState<boolean>(false)


    const [flagChangeScenario, setFlagChangeScenario] = useState<boolean>(true)

    
    const {id}:any = useParams()

    const [scenarioToCompare, setScenarioToCompare] = useState<number>(id)

    const [tabID, setTabID] = useState<number>(1)

    const handleTabID = (e:any) => {
       
        const { innerText } = e.target

        switch(innerText) {
            case 'Entregas':
                setTabID(1)
                break;
            case 'Proveedores':
                setTabID(2)
                break;
            case 'Stock Total':
                setTabID(3)
                break;
            case 'Camiones':
                setTabID(4)
                break;
            default:
                
        }
    }

    const renderComparativaLoader = () => {
        if(deleteLoading) {
            return 'Eliminando escenario operativo'
        } else {
            switch(tabID) {
                case 1:
                    return 'Obteniendo información de las entregas'
                case 2:
                    return 'Obteniendo información de los proveedores'
                case 3:
                    return 'Obteniendo información del stock total'
                case 4:
                    return 'Obteniendo información de los camiones'
            }
        }
        
    }

    const emptyData = () => {

        if(tabID !== 1) {
            setEntregas(INITIAL_STATE_ENTREGAS)
            setEntregasMASTER(INITIAL_STATE_ENTREGAS)
        }
        
        if(tabID !==2) {
            setProveedores(INITIAL_STATE_PROVEEDORES)

            setProveedoresMASTER(INITIAL_STATE_PROVEEDORES)
        }
        
        if(tabID !== 3) {
            setStock({
                stock_kpis: [],
                stock_series : []
            }) 

            setStockMASTER({
                stock_kpis: [],
                stock_series : []
            })
        }
        
        if(tabID !== 4) {
            setTrucks([])
            setTrucks([])
        }


    }



    const fetchOperativeScenarioByTabID = async() => {
        try {
            setLoadingScenarioComparision(true)
            let body;
            
            if(!date && !week) {
                setDate(new Date())
                setWeek({
                    firstDay: startOfWeek(new Date(), { weekStartsOn: 1 }),
                    lastDay: endOfWeek(new Date(), { weekStartsOn: 1 })
                })
                body = {
                    id_scenario: id,
                    id_tab: tabID,
                    provider_week : getWeekNumber(startOfWeek(new Date(), { weekStartsOn: 1 })),
                    provider_year : startOfWeek(new Date(), { weekStartsOn: 1 }).getFullYear()
                    
                }
            } else {
                body = {
                    id_scenario: id,
                    id_tab: tabID,
                    provider_week : getWeekNumber(week.firstDay) ,
                    provider_year : week.firstDay.getFullYear()
                    
                }
            }
            
            const res = await getOperativeScenarioByTabID(body)
            if(res.status === 200) {
                const {code,data,message} = res.data
                if(code === 200) {
                    setLoadingScenarioComparision(false)
                    setScenarioBase(data.scenario)

                    switch(tabID) {
                        case 1:   
                            setEntregas(data.settings.entregas.entregas_table)
                            setEntregasMASTER(data.settings.entregas.entregas_table)
                            emptyData()
                            break;

                        case 2:
                            setProveedores(data.settings.proveedores)
                            setProveedoresMASTER(data.settings.proveedores)
                            
                            emptyData()
                            break;

                        case 3:
                            setStock(data.settings.stock)
                            setStockMASTER(data.settings.stock)
                            emptyData()
                            break;
                        
                        case 4:
                            setTrucks(data.settings.camiones.camiones_table)
                            setTrucksMASTER(data.settings.camiones.camiones_table)
                            emptyData()
                            break;
                    }
                    setLoadingTab(false)
                    setLoadingScenarioComparision(false)
                } else if( code === 400) {
                    warning(message)
                    setScenarioBase(INITIAL_STATE_SCENARIO)
                    setLoadingScenarioComparision(false)
                    setLoadingTab(false)
                    setLoadingScenarioComparision(false)
                } else {
                    error(message)
                    setScenarioBase(INITIAL_STATE_SCENARIO)
                    setEntregas(INITIAL_STATE_ENTREGAS)
                    setEntregasMASTER(INITIAL_STATE_ENTREGAS)
                    setStock(INITIAL_STATE_STOCK)
                    setStockMASTER(INITIAL_STATE_STOCK)
                    setTrucks([])
                    setTrucksMASTER([])
                    setProveedores(INITIAL_STATE_PROVEEDORES)
                    setProveedoresMASTER(INITIAL_STATE_PROVEEDORES)
                    setLoadingScenarioComparision(false)
                    setLoadingTab(false)
                    setLoadingScenarioComparision(false)
                }
            } else {
                setLoadingScenarioComparision(false)
                setScenarioBase(INITIAL_STATE_SCENARIO)
                setEntregas(INITIAL_STATE_ENTREGAS)
                setEntregasMASTER(INITIAL_STATE_ENTREGAS)
                setStock(INITIAL_STATE_STOCK)
                setStockMASTER(INITIAL_STATE_STOCK)
                setTrucks([])
                setTrucksMASTER([])
                setProveedores(INITIAL_STATE_PROVEEDORES)
                setProveedoresMASTER(INITIAL_STATE_PROVEEDORES)
                error("Error obteniendo la información del escenario")
                setLoadingTab(false)
                setLoadingScenarioComparision(false)
            }
        } catch(err:any){
           
            catchResponse(err)
            setLoadingScenarioComparision(false)
            setScenarioBase(INITIAL_STATE_SCENARIO)
            setEntregas(INITIAL_STATE_ENTREGAS)
            setEntregasMASTER(INITIAL_STATE_ENTREGAS)
            setStock(INITIAL_STATE_STOCK)
            setStockMASTER(INITIAL_STATE_STOCK)
            setTrucks([])
            setTrucksMASTER([])
            setProveedores(INITIAL_STATE_PROVEEDORES)
            setProveedoresMASTER(INITIAL_STATE_PROVEEDORES)
            setLoadingTab(false)
            setLoadingScenarioComparision(false)
        }
    }

   

    const handleRestart = () => {
        setFlagChangeScenario(!flagChangeScenario)
        warning("Se han recargado los datos con los valores iniciales.")
    }

    const handleSaveData = async() => {
        try {
            setSaveLoading(true)
            let body;
            
          
            switch(tabID) {
                case 1:
                    
                    let entregas_table_edited = entregas.filter((pt:any) => 'edited' in pt && pt.edited === true)

                    body = {
                        id_scenario: parseInt(id),
                        id_tab: tabID,
                        settings : {
                            entregas: {
                                entregas_table: entregas_table_edited,
                            }
                        }
                        
                    }
                    break;
                case 2:
                    
                    let herbaceo_proveedor_table_edited = proveedores.herbaceo.herbaceo_proveedores_table.filter((pt:any) => 'edited' in pt && pt.edited === true)
                    let herbaceo_propio_table_edited = proveedores.herbaceo.herbaceo_propio_table.filter((pt:any) => 'edited' in pt && pt.edited === true)
                    let lenhoso_proveedor_table_edited = proveedores.lenhoso.lenhoso_proveedores_table.filter((pt:any) => 'edited' in pt && pt.edited === true)
                    let lenhoso_propio_table_edited = proveedores.lenhoso.lenhoso_propio_table.filter((pt:any) => 'edited' in pt && pt.edited === true)
                    body = {
                        id_scenario: parseInt(id),
                        id_tab: tabID,
                        provider_week : getWeekNumber(week.firstDay),
                        provider_year : week.firstDay.getFullYear(),
                        settings : {
                            proveedores: {
                                herbaceo: {
                                    herbaceo_propio_table:herbaceo_propio_table_edited,
                                    herbaceo_proveedores_table:herbaceo_proveedor_table_edited
                                },
                                lenhoso : {
                                    lenhoso_propio_table:lenhoso_propio_table_edited,
                                    lenhoso_proveedores_table:lenhoso_proveedor_table_edited
                                }
                            }
                        }
                        
                    }
                    break;
                case 4:

                    let camiones_table_edited = trucks.filter((pt:any) => 'edited' in pt && pt.edited === true)
                    
                    body = {
                        id_scenario: parseInt(id),
                        id_tab: tabID,
                        settings : {
                            camiones: {
                                camiones_series : [],
                                camiones_table: camiones_table_edited,
                            }
                        }
                        
                    }
                    break;
            }

            const res = await updateOperativeScenario(body)
            if(res.status === 200) {
                const {code} = res.data
                if(code === 200) {
                    setSaveLoading(false)
                    success("Información modificada exitosamente")
                    setFlagChangeScenario(!flagChangeScenario)
                }
            } else {
                setSaveLoading(false)
            }
        } catch (err:any) {
            setSaveLoading(false)
            catchResponse(err)
        }
    }

   
    const fetchAllEscenarios = async() => {
        try {
            const res = await getAllScenarios()
            if(res.status === 200) {
                const { code, data } = res.data
                if( code === 200) {
                    let sorted_data = [{...data[0],plants:data[0].plants.sort((a:any,b:any) => a.id_plant - b.id_plant)},{...data[1],plants:data[1].plants.sort((a:any,b:any) => a.id_plant - b.id_plant)}]
                    setAllScenarios(sorted_data)
                    setSimulatedScenarios(sorted_data[0]?.plants[sorted_data[1]?.plants.map((pa:any) => pa.scenarios).map((c:any) => c[0].id_scenario).findIndex((i:any) => i == id)].scenarios?.filter((s:any) => s.simulado))
                    } else {
                    setAllScenarios([])
                    error("No se pueden obtener los escenarios")
                }
            } else {
                setAllScenarios([])
                setSimulatedScenarios([])
                error("No se pueden obtener los escenarios")
            }
        } catch(err) {
            setAllScenarios([])
            setSimulatedScenarios([])
            error("No se pueden obtener los escenarios")
        }
    }

    useEffect(() => {
        setLoadingScenarioComparision(true)
        fetchAllEscenarios()
    }, [flagChangeScenario,id])


    useEffect(() => {
        setLoadingTab(true)
        fetchOperativeScenarioByTabID()
    },[tabID,flagChangeScenario,flagWeek,id])
    
    return (
        <div className="scenario_plan__wrapper">
            <ChangeReferenceSimulationModal
                visible={visible}
                setVisible={setVisible}
                flagChangeScenario={flagChangeScenario}
                setFlagChangeScenario={setFlagChangeScenario}
                simulatedScenarios={simulatedScenarios}
                referenceSimulationID={scenarioBase.simulation}
                
                scenarioId={scenarioBase.id_scenario}
            />
            <div>
                <div className="scenario__header-name">
                    
                    <ScenarioSelector name={scenarioBase?.name_planner} allScenarios={allScenarios} plant={scenarioBase?.id_plant} disabled={loadingScenarioComparision || loadingTab || deleteLoading} scenarioToCompare={scenarioToCompare} setScenarioToCompare={setScenarioToCompare} setFlagChangeScenario={setFlagChangeScenario} flagChangeScenario={flagChangeScenario} title={`(${scenarioBase?.name_plant})`} color={'var(--lis-dark)'} base={true} operative={true} simulatedScenarios={simulatedScenarios} setSimulatedScenarios={setSimulatedScenarios} />
                    <div className="scenario__header-input" >
                        <span className="p-inputgroup-addon" style={{backgroundColor:'var(--lis-dark)',color:'white'}}>
                            <HiOutlineIdentification style={{fontSize:20}} />
                        </span>
                        <InputText className="scenario-inputs" placeholder="Nombre de escenario" keyfilter="alphanum"  value={`${scenarioBase?.name_scenario}`} disabled />
                    </div>
                </div>
                <>
                    <span style={{minWidth:30}}></span>
                    <div style={{minWidth:'35%',display:'flex',justifyContent:'center',alignItems:'center'}}>
                        <span style={{fontFamily:'var(--roboto-medium)',fontSize:'0.75rem',marginRight:'1rem',cursor:'default'}}>Simulación referencia:</span>
                        <Button disabled={loadingScenarioComparision} style={{cursor:'default'}}  className="reference-simulation__btn" label={simulatedScenarios?.find((ss:any) => ss.id_scenario === scenarioBase.simulation)?.name_scenario} rounded>
                            <FaStar style={{marginLeft:'1rem'}} />
                        </Button>
                    </div>
                    <span style={{minWidth:'10%'}}></span>
                </>

                <div className="scenario__header-settings">
                    <Tooltip target=".speeddial-scenario .p-speeddial-action" position="bottom" style={{fontSize:'0.75rem'}} />
                    <SpeedDial disabled={deleteLoading}  className="speeddial-scenario" model={items} direction="left" transitionDelay={80} showIcon="pi pi-cog" hideIcon="pi pi-times" buttonClassName="p-button-outlined" />
                </div>
                
            </div>

           
            <ConfirmPopup />
            <div>
                
                    
                
                <div className="card" style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                    <TabView onClick={handleTabID}>
                        <TabPanel disabled={loadingTab || deleteLoading} header={<span style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <BsFillSendCheckFill size={16} style={{marginRight:'0.75rem'}} onClick={() => handleTabID({target:{innerText:'Entregas'}})} />Entregas</span>}>
                            
                        </TabPanel>
                        
                        <TabPanel disabled={loadingTab || deleteLoading} header={<span style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <FaPeopleCarry size={16} style={{marginRight:'0.75rem'}} onClick={() => handleTabID({target:{innerText:'Proveedores'}})} />Proveedores</span>}>
                            
                        </TabPanel>
                        <TabPanel disabled={loadingTab || deleteLoading} header={<span style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <AiOutlineStock size={16} style={{marginRight:'0.75rem'}} onClick={() => handleTabID({target:{innerText:'Stock Total'}})} />Stock Total</span>} >
                           
                        </TabPanel>
                    </TabView>
                    <div className="scenario_table_options">
                        
                        <Button rounded outlined onClick={handleRestart} tooltip="Reiniciar datos" tooltipOptions={{ position: 'left',className:"scenario-tooltip-restart"}} style={{padding:'0.45rem',marginBottom:5}} disabled={saveLoading || deleteLoading || (state?.rol_id !== undefined? [3,4].includes(state.rol_id) && !state.id_plants.includes(scenarioBase.id_plant) : false)} >
                            <VscDebugRestart  size={20}  />
                        </Button>
                        
                        <Button disabled={changesFlag || saveLoading || (state?.rol_id !== undefined? [3,4].includes(state.rol_id) || !state.id_plants.includes(scenarioBase.id_plant) : false)} rounded outlined   style={{padding:'0.45rem', color:'green',marginBottom:5}} tooltip={saveLoading? "Guardando..." :"Guardar modificaciones"} tooltipOptions={{ position: 'left',className:"scenario-tooltip-restart"}}  >
                            {
                                saveLoading?
                                <FiCommand className="loading-icon" style={{fontSize:20}} />
                                :
                                <AiFillSave size={22} onClick={handleSaveData} />
                            }

                        </Button>
                        
                    </div>
                </div>
                
                {
                    
                    loadingScenarioComparision || loadingTab || deleteLoading?
                            <div style={{height:'95%',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                                {/*<Spinner message={comparativa?`Obteniendo comparativa de escenarios` : `Obteniendo información del escenario`}/>*/}
                                <FiCommand className="loading-icon" style={{fontSize:40,color:'var(--lis-dark)',opacity:0.6}} />
                                <span  style={{fontFamily:'var(--roboto-medium)',color:'gray',marginTop:'1rem'}}>{renderComparativaLoader()}</span>   
                            </div>
                            
                        :
                        tabID === 1?
                            <Entregas 
                                entregas={entregas}
                                setEntregas={setEntregas}
                                entregasMASTER={entregasMASTER}
                                setEntregasMASTER={setEntregasMASTER}
                                changesFlag={changesFlag}
                                setChangesFlag={setChangesFlag}
                                flagChangeScenario={flagChangeScenario}
                                setFlagChangeScenario={setFlagChangeScenario}
                                id={id}
                                tabID={tabID}
                            />                           
                            :
                            tabID === 2?
                                <Proveedores 
                                    proveedores={proveedores}
                                    setProveedores={setProveedores}
                                    proveedoresMASTER={proveedoresMASTER}
                                    setProveedoresMASTER={setProveedoresMASTER}
                                    flagWeek={flagWeek}
                                    setFlagWeek={setFlagWeek}
                                    date={date}
                                    setDate={setDate}
                                    week={week}
                                    setWeek={setWeek}
                                    changesFlag={changesFlag}
                                    id={id}
                                    setChangesFlag={setChangesFlag}
                                    tabID={tabID}
                                /> 
                                :
                                tabID === 3?
                                    <StockInicial
                                        stock={stock}
                                        setStock={setStock}
                                        stockMASTER={stockMASTER}
                                        setStockMASTER={setStockMASTER} 
                                        changesFlag={changesFlag}
                                        setChangesFlag={setChangesFlag}
                                        flagChangeScenario={flagChangeScenario}
                                        setFlagChangeScenario={setFlagChangeScenario}
                                        id={id}
                                        tabID={tabID}
                                    /> 
                                    : 
                                    <Trucks
                                        trucks={trucks}
                                        setTrucks={setTrucks}
                                        trucksMASTER={trucksMASTER}
                                        setTrucksMASTER={setTrucksMASTER}
                                        changesFlag={changesFlag}
                                        setChangesFlag={setChangesFlag}
                                        flagChangeScenario={flagChangeScenario}
                                        setFlagChangeScenario={setFlagChangeScenario}
                                        id={id}
                                        tabID={tabID}
                                    />
                }
               
            </div>
            
        </div>
    )
}